module.exports = __webpack_public_path__ + "static/img/loginbg.c75eceb6.jpeg";